import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";

export const startLoadingContinents = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CONTINENT}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingContinents(body.continents));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const loadingContinents = (continents) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_CONTINENT,
  payload: continents,
});

export const selectContinent = (continent) => ({
  type: types.LOCATIONCOUNTRY_SELECT_CONTINENT,
  payload: continent,
});

export const cleanContinent = () => ({
  type: types.LOCATIONCOUNTRY_CLEAN_CONTINENT,
});
